import Hero from "@/pages/home/components/Hero";
import HowWeWork from "@/pages/home/components/HowWeWork";
import Invitation from "@/pages/home/components/Invitation";
import Manifesto from "@/pages/home/components/Manifesto";
import Navbar from "@/pages/home/components/Navbar";
import Services from "@/pages/home/components/Services";
import WhatIsTherapy from "@/pages/home/components/WhatIsTherapy";

export default function Home() {
  return (
    <div className="relative w-full">
      <Navbar />
      <Hero />
      <Services />
      <Manifesto />
      <WhatIsTherapy />
      <HowWeWork />
      <Invitation />
    </div>
  );
}